import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=1ce96c2b&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=ts"
export * from "./CourseItem.vue?vue&type=script&lang=ts"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=1ce96c2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce96c2b",
  null
  
)

export default component.exports